import React, { Component } from 'react';

import Product from '../Product';
// import TypeText from '../../TypeText';

import style from './index.module.scss';

export default class Picks extends Component {
  render() {
    const { products, primaryColor, shape } = this.props;
    // console.log('show and products', show, products);
    return (
      <div className={style.picks}>
        <div className={style.title}>
          <div className={style.type}>{"Your Beauty Buys"}</div>
        </div>
        <div className={style.products}>
          {products.map((product, index) => <Product {...product} primaryColor={primaryColor} shape={shape} key={`product-${index}`} />)}
        </div>
      </div>
    )
  }
}
